import relationshipService from '../../../../../services/relationship/RelationshipService';
import interventionService from '../../../../../services/intervention/InterventionService';
import userService from '../../../../../services/user/UserService';
import {captureError} from '../../../../../utils/log';
import {status} from '../../../../../utils/constant';
import documentKpiService from '../../../../../services/documentKpi/DocumentKpiService';

export const getUserCount = ({organisation}) => new Promise((resolve, reject) => {
  userService.searchByOrganisation(organisation.organisationId, '', 0, 1)
    .then(({totalCount}) => {
      resolve(totalCount);
    })
    .catch(error => {
      captureError('Error while fetching organisation user count', error);
      reject();
    });
});

export const getClientCount = ({organisation, userId}) => new Promise((resolve, reject) => {
  const searchParams = [
    organisation.organisationId,
    status.ACCEPTED,
    userId,
    '',
    0,
    1
  ];

  relationshipService.searchClientsByQuery(...searchParams)
    .then(({totalCount}) => {
      resolve(totalCount);
    })
    .catch(error => {
      captureError('Error while fetching organisation client count', error);
      reject();
    });
});

export const getProjectCount = ({organisation}) => new Promise((resolve, reject) => {
  const searchParams = [
    organisation.organisationId,
    '',
    0,
    1
  ];

  interventionService.searchByQuery(...searchParams)
    .then(({totalCount}) => {
      resolve(totalCount);
    })
    .catch(error => {
      captureError('Error while fetching organisation intervention count', error);
      reject();
    });
});

export const getSubcontractorKPI = ({organisation}) => new Promise((resolve, reject) => {
  documentKpiService.getValidSubcontractorsDossierStatesPercentageByOrganisation(organisation.organisationId)
    .then(response => {
      resolve(response);
    })
    .catch(error => {
      captureError('Error while fetching organisation subcontractors KPI', error);
      reject();
    });
});
